<span class="badge" [ngClass]="ngClass"><ng-content></ng-content></span>
